var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('BaseCard',{attrs:{"imageURL":"rux-floating.jpg","routerLink":{
      name: 'List',
    }}},[_vm._v(" View All My RUX")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }